import { styled as muiStyled } from '@mui/system';
import { Alert } from '@mui/material';

type Severity = 'error' | 'warning' | 'info' | 'success';

interface SignAlertProps {
  severity: Severity;
  children: string;
}

function SignAlert({ severity, children }: SignAlertProps): React.ReactElement {
  const CustomAlert = muiStyled(Alert)({
    marginTop: 30,
  });

  return <CustomAlert severity={`${severity}`}>{children}</CustomAlert>;
}

export default SignAlert;
